import type { SxProps, Theme } from "@mui/material";
import {
	formFieldPlaceholderColor,
	formFieldSelectedColor,
	formMenuItem,
	formMenuItemLayoutSx,
	formPrimary,
	selectControlSx,
} from "@config/theme/formControls";

export {
	selectControlSx,
	selectOutlinedInputSx,
	mergeSelectSx,
	defaultSelectMenuProps,
	formSelectPlaceholderClassName,
	formSelectValueClassName,
} from "@config/theme/formControls";

export const menuPaperSx: SxProps<Theme> = {
	borderRadius: 2,
	boxShadow: "0 2px 8px 0 rgba(16, 24, 40, 0.04)",
	mt: 1,
};

export const menuZIndexSx = {
	zIndex: 10001,
};

export const SELECT_DROPDOWN_LIST_MAX_HEIGHT = "min(320px, 45vh)";

export const menuItemSx = (isPlaceholder: boolean, isDisabled = false): SxProps<Theme> => ({
	...formMenuItemLayoutSx,
	...(isPlaceholder && {
		color: "#98A2B3",
		fontStyle: "normal",
		fontFamily: "Poppins, sans-serif",
		fontSize: "12px",
		fontWeight: "400",
		"&.Mui-disabled": {
			color: "#98A2B3 !important",
			backgroundColor: "transparent !important",
		},
		"&.Mui-selected": {
			backgroundColor: "transparent !important",
			color: "#98A2B3 !important",
		},
		"&.Mui-selected:hover": {
			backgroundColor: formMenuItem.hoverBg,
			color: formMenuItem.hoverColor,
		},
		"&.Mui-focusVisible": {
			backgroundColor: "transparent",
		},
	}),
	...(!isPlaceholder && {
		fontFamily: "Poppins, sans-serif",
		fontSize: "12px",
		fontWeight: "400",
		"&:hover": {
			backgroundColor: formMenuItem.hoverBg,
			color: formMenuItem.hoverColor,
		},
		"&.Mui-selected": {
			backgroundColor: formMenuItem.selectedBg,
			color: formMenuItem.selectedColor,
			borderRadius: 1,
		},
		"&.Mui-selected:hover": {
			backgroundColor: formMenuItem.selectedHoverBg,
			color: formMenuItem.selectedColor,
		},
		...(isDisabled && {
			"&.Mui-disabled": {
				opacity: 0.55,
			},
		}),
	}),
});

export const selectRenderValuePlaceholderSx: SxProps<Theme> = {
	color: formFieldPlaceholderColor,
	fontStyle: "normal",
	fontSize: "14px",
	fontFamily: "Poppins, sans-serif",
	fontWeight: "400",
};

export const selectRenderValueSelectedSx: SxProps<Theme> = {
	color: formFieldSelectedColor,
	fontFamily: "Poppins, sans-serif",
	fontSize: "14px",
	fontWeight: "400",
	overflow: "hidden",
	textOverflow: "ellipsis",
	whiteSpace: "nowrap",
	display: "block",
	maxWidth: "100%",
};

export const menuItemContentSx: SxProps<Theme> = {
	display: "flex",
	alignItems: "center",
	gap: "4px",
	width: "100%",
	minWidth: 0,
};

export const menuItemLabelSx: SxProps<Theme> = {
	flex: 1,
	fontFamily: "Poppins, sans-serif",
	fontSize: "12px",
	fontWeight: "400",
	whiteSpace: "pre-line",
};

export const listItemIconSx: SxProps<Theme> = {
	color: "#fff",
};

export const checkIconSx: SxProps<Theme> = {
	marginLeft: "auto",
	color: formPrimary,
};

/** @deprecated Use mergeSelectSx — kept for legacy imports */
export const selectSx = selectControlSx;
